import { MessageItemProps } from "apis";
import { lazy } from "react";

export const PageAdminMessage = lazy(() => import("./List"));
export const PageAdminMessageCreate = lazy(() => import("./Add"));
export const PageAdminMessageUpdate = lazy(() => import("./Edit"));

export interface FormMessageValuesProps extends MessageItemProps { }